import { Outlet } from "react-router-dom";

const SubscriptionRoot = () => {
  return (
    <div>
      <Outlet/>
    </div>
  );
};

export default SubscriptionRoot;